<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="3">
                <v-checkbox v-model="isSharedWithAll" label="Share with All Teams" :readonly="readonly"></v-checkbox>
            </v-col>
            <v-col cols="12" md="9">
                <v-autocomplete
                    v-model="currentTeams"
                    :items="teams"
                    label="Shared with..."
                    item-text="name"
                    item-value="id"
                    multiple
                    chips
                    :disabled="isSharedWithAll"
                    :readonly="readonly"
                ></v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <div class="float-right">
                    <v-btn :loading="isSaving" :disabled="isSaving || readonly" color="secondary" @click="saveShares"
                        >Save</v-btn
                    >
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import api from '@/api'
export default {
    name: 'sharemanager',
    props: {
        shareAll: {
            type: Boolean,
            required: true,
        },
        shares: {
            type: Array,
            required: true,
        },
        isSaving: {
            type: Boolean,
            required: true,
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            isLoading: false,
            teams: [],
            currentTeams: [],
            removedTeams: [],
            addedTeams: [],
            isSharedWithAll: false,
        }
    },
    mounted() {
        this.getTeams()
        this.isSharedWithAll = this.shareAll
        this.currentTeams = this.shares
    },
    watch: {
        shareAll() {
            this.isSharedWithAll = this.shareAll
        },
        shares() {
            this.currentTeams = this.shares
        },
    },
    methods: {
        getTeams() {
            this.isLoading = true
            api.get('/team/getAllActive')
                .then(res => {
                    this.teams = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        saveShares() {
            this.$emit('save', this.isSharedWithAll, this.currentTeams)
        },
    },
}
</script>
